import * as React from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { Tabs, Tab } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { getResultsByIndex } from '../../Algolia/utils/get-results-by-index.js';

function lowercaseAndCapitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
const SearchTabs = ({ setActiveTabIndex , activeTabIndex , indexes , productIndex  })=>{
    const { scopedResults  } = useInstantSearch();
    const { getLabel  } = useIntl();
    const productSuggestions = getResultsByIndex(scopedResults, productIndex.name);
    const contentSuggestions = indexes.contentIndex && getResultsByIndex(scopedResults, indexes.contentIndex.name);
    const productLabel = lowercaseAndCapitalize(getLabel('search.suggestions.products.title'));
    const contentLabel = lowercaseAndCapitalize(getLabel('search.suggestions.content.title'));
    var ref, ref1;
    return /*#__PURE__*/ React.createElement(Tabs, {
        onChange: setActiveTabIndex,
        activeTabIndex: activeTabIndex
    }, /*#__PURE__*/ React.createElement(Tab, {
        label: `${productLabel} (${(ref = productSuggestions === null || productSuggestions === void 0 ? void 0 : productSuggestions.nbHits) !== null && ref !== void 0 ? ref : 0})`
    }), /*#__PURE__*/ React.createElement(Tab, {
        label: `${contentLabel} (${(ref1 = contentSuggestions === null || contentSuggestions === void 0 ? void 0 : contentSuggestions.nbHits) !== null && ref1 !== void 0 ? ref1 : 0})`
    }));
};

export { SearchTabs, SearchTabs as default };
//# sourceMappingURL=SearchTabs.js.map
